import { defineMessages } from 'react-intl';

export default defineMessages({
    edit: {
        id: 'ml.quoteandbind.common.driverTables.edit',
        defaultMessage: 'Edit'
    },
    insure: {
        id: 'ml.quoteandbind.common.driverTables.insure',
        defaultMessage: 'Insure'
    },
    remove: {
        id: 'ml.quoteandbind.common.driverTables.remove',
        defaultMessage: 'Remove'
    },
    dob: {
        id: 'ml.quoteandbind.common.driverTables.dob',
        defaultMessage: 'DATE OF BIRTH'
    },
    name: {
        id: 'ml.quoteandbind.common.driverTables.name',
        defaultMessage: 'NAME'
    },
    gender: {
        id: 'ml.quoteandbind.common.driverTables.gender',
        defaultMessage: 'GENDER'
    },
    maritalStatus: {
        id: 'ml.quoteandbind.common.driverTables.maritalStatus',
        defaultMessage: 'MARITAL STATUS'
    },
    relToIns: {
        id: 'ml.quoteandbind.common.driverTables.relToIns',
        defaultMessage: 'RELATIONSHIP TO INSURED'
    },
    statusCell: {
        id: 'ml.quoteandbind.common.driverTables.statusCell',
        defaultMessage: 'REASON NOT LISTED'
    },
    actions: {
        id: 'ml.quoteandbind.common.driverTables.actions',
        defaultMessage: 'ACTIONS'
    },
    noInfoExists: {
        id: 'ml.quoteandbind.common.driverTables.noInfoExists',
        defaultMessage: 'No Information Exists'
    },
    noDriversForQuote: {
        id: 'ml.quoteandbind.common.driverTables.noDriversForQuote',
        defaultMessage: 'There are no {driverType} for this quote'
    },
    excludedDrivers: {
        id: 'ml.quoteandbind.common.driverTables.excludedDrivers',
        defaultMessage: 'excluded drivers'
    },
    otherHouseholdMembers: {
        id: 'ml.quoteandbind.common.driverTables.otherHouseholdMembers',
        defaultMessage: 'other household members'
    },
    pfm: {
        id: 'ml.quoteandbind.common.driverTables.pfm',
        defaultMessage: 'PFM'
    },
});
